import React, { Fragment } from 'react';
import { InspirationalPicture } from 'Components/widgets/inspirational-grid/InspirationalPicture';
import { InspirationalDescription } from 'Components/widgets/inspirational-grid/InspirationalDescription';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import {
  getContainerStyles,
  HORIZONTAL_CONTAINER_RATIO,
  VERTICAL_RATIO,
  HORIZONTAL_RATIO,
} from 'Components/widgets/inspirational-grid/InspirationalGrid';
export const InspirationalGridHorizontal = ({
  pictures,
  title,
  subtitle,
  description,
}: InspirationalGridProps) => {
  const containerStyles = getContainerStyles(HORIZONTAL_CONTAINER_RATIO);
  const margin = {
    margin: '0 calc(20 / 1180 * 100%)',
  };
  return (
    <Fragment>
      <InspirationalDescription
        title={title}
        subtitle={subtitle}
        description={description}
        centered
      />
      <div className="relative h-0 w-full" style={containerStyles}>
        <div className="absolute inset-0 flex">
          <div className="flex items-center">
            <InspirationalPicture
              ratioKey={VERTICAL_RATIO}
              ratioDisplay={1 / 4}
              {...pictures[0]}
              index={1}
            />
          </div>
          <div className="flex shrink-0" style={margin}>
            <InspirationalPicture
              ratioKey={HORIZONTAL_RATIO}
              imgClassName="h-full"
              ratioDisplay={1 / 2}
              {...pictures[1]}
              index={2}
            />
          </div>
          <div className="flex items-center">
            <InspirationalPicture
              ratioKey={VERTICAL_RATIO}
              ratioDisplay={1 / 4}
              {...pictures[2]}
              index={3}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
